module.exports = __webpack_public_path__ + "static/media/watchlist-active.89c465c1.svg";